<script setup lang="ts">
import ConfirmationModal from '@/core/components/ConfirmationModal.vue';
import { useKeycloak } from '@nxtpeople/nxt-vue-keycloak';

// #region reset
const { keycloak } = useKeycloak();

const reset_modal_opened = ref<boolean>(false);
const is_resetting = ref<boolean>(false);
async function reset(skipLogout?: boolean) {
   try {
      clearAllCache();
      localStorage.clear();

      const REGISTRATIONS = await navigator.serviceWorker.getRegistrations();
      await Promise.allSettled(
         REGISTRATIONS.map((registration) => {
            registration.unregister();
         }),
      );

      if (skipLogout) {
         window.location.reload();
         return;
      }
      keycloak.logout({ redirectUri: window.location.origin });
   } catch (error) {
      window.location.reload();
   }
}
// #endregion

defineExpose({ reset });
</script>

<template>
   <div class="profile">
      <NxtSection :title="$t('settings.data-settings')">
         <div class="profile__item profile__item__reset">
            <span>{{ $t('actions.click_here_to_reset') }}</span>
            <NxtButton class="content__item__action" @click.prevent="reset_modal_opened = true">{{ $t('actions.reset') }}</NxtButton>
         </div>
      </NxtSection>
   </div>

   <Teleport v-if="reset_modal_opened" to="body">
      <ConfirmationModal :loading="is_resetting" :confirm-text="$t('actions.reset')" @close="reset_modal_opened = false" @confirm="reset">
         {{ $t('actions.reset_confirmation') }}
      </ConfirmationModal>
   </Teleport>
</template>

<style lang="scss" scoped>
.profile__item {
   padding: var(--nxt-gutter);
}

.profile__item__reset {
   display: flex;
   flex-direction: column;
   gap: var(--nxt-gutter);

   :deep(.nxt-button) {
      width: fit-content;
   }
}
</style>
